import React from 'react'
import Card from '../shared/card/card.jsx'

const JobActivityCard = ({card, hide, show, border, borderColor}) => {
  let midIconRoot = '/common/latest/images/consumer/history-icons/'
  let imageName
  if (card.activityType === 'RESCHEDULED') {
    imageName = card.activityType + '-flat.png'
  } else if(card.subActivityType === 'INCOMPLETE' || card.subActivityType === 'SECOND_ATTEMPT') {
    imageName = 'CREATED-flat.png'
  } else {
    imageName = card.subActivityType + '-flat.png'
  }
  let midIcon = midIconRoot + imageName
  let borderSide

  if (border) {
    borderSide = 'left'
  } else {
    borderSide = 'right'
  }

  return (
    <Card
      isJobActivity
      border={borderSide}
      borderColor={borderColor}
      headerTitle={card.title}
      headerMidIcon={midIcon}
      additionalClasses={'history-pull-down'}
      cardBottomPadding='30px'>
      <p dangerouslySetInnerHTML={{ __html: card.content }} />
      <a style={{float: 'right', fontWeight: 500, fontSize:'14px'}} onClick={show} >MORE INFO</a>
    </Card>
  )
}

JobActivityCard.propTypes = {
  card: React.PropTypes.object.isRequired
}

export default JobActivityCard



// WEBPACK FOOTER //
// ./src/components/history/job-activity-card.jsx